<template>
  <div class="date_with_menu">
    <!-- <span style="position: absolute; top: -3px; left: 0; font-size: 0.7rem">{{
      placeholder
    }}</span> -->
    <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="values"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="values"
            label="Выбрать дату"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="values"
          no-title
          scrollable
          range
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            @click="menu = false"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="$refs.menu.save(values)"
          >
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
    <!-- <v-text-field
      v-if="values.length > 0 && values[0] !== ''"
      :value="label"
      prepend-icon="mdi-calendar"
      readonly
      style="position: relative; top: 10px"
      append-icon="close"
      @click:append="cleareble"
      @click="menu = !menu"
    />
    <v-text-field
      prepend-icon="mdi-calendar"
      readonly
      style="position: relative; top: 10px"
      v-else
      @click="menu = !menu"
    />
    <div v-if="menu" class="menu" @focusout="menu = false">
      <v-radio-group v-model="days" @change="menu = false">
        <v-radio
          v-for="item in items"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        />
      </v-radio-group>
    </div> -->
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "date_with_menu",
  components: {},
  data: () => ({
    menu: false,
    days: 1,
  }),
  props: {
    placeholder: { type: String, default: "Дата" },
    items: { type: Array },
    value: { type: Array },
    init: { type: Boolean, default: true },
  },
  computed: {
    values: {
      get() {
        return this.value;
      },
      set(Val) {
        this.$emit("input", Val);
      },
    },
    label: {
      get() {
        return `${this.values[0].split("-")[2]}-${
          this.values[0].split("-")[1]
        }-${this.values[0].split("-")[0]}, ${this.values[1].split("-")[2]}-${
          this.values[1].split("-")[1]
        }-${this.values[1].split("-")[0]}`;
      },
    },
  },
  methods: {
    setDate() {
      const date = [];
      const nowDate = moment().format("YYYY-MM-DD");
      const date_to = moment(nowDate)
        .add(this.days, "days")
        .format("YYYY-MM-DD");
      date.push(nowDate);
      date.push(date_to);
      this.values = date;
    },
    cleareble() {
      this.values = ["", ""];
    },
  },
  watch: {
    days() {
      this.value.length > 0 && this.setDate();
    },
    value() {
      this.value.length == 0 && (this.days = null);
    },
    placeholder() {
      if (this.value[0] === "" && this.value[1] === "") {
        this.setDate();
      }
    },
  },
  created() {
    if (this.init) {
      this.setDate();
    }
  },
};
</script>
<style lang="sass" scoped>
.date_with_menu
  position: relative
  width: 230px
  z-index: 999999
.menu
  position: fixed
  background-color: white
  display: flex
  padding: 20px
  box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%)
  z-index: 999999
</style>
